<div
	class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1.5 sm:tw-gap-x-3 sm:tw-gap-y-0 sm:tw-flex-nowrap tw-px-3 tw-py-2.5 sm:tw-px-4 sm:tw-py-3 tw-rounded-lg sm:tw-rounded-xl tw-border tw-transition-colors hover:tw-bg-gray-50/80"
	[ngClass]="{
		'tw-bg-green-50/50 tw-border-green-200/60': assessment.score >= 4,
		'tw-bg-blue-50/50 tw-border-blue-200/60': assessment.score === 3,
		'tw-bg-amber-50/50 tw-border-amber-200/60': assessment.score === 2,
		'tw-bg-red-50/50 tw-border-red-200/60': assessment.score < 2,
		'tw-cursor-pointer hover:tw-ring-2 hover:tw-ring-[#243670]/20': allowRescore
	}"
	[attr.role]="allowRescore ? 'button' : null"
	[attr.tabindex]="allowRescore ? 0 : null"
	[attr.aria-label]="allowRescore ? 'Re-score ' + (assessment.question?.question || 'challenge') : null"
	(click)="allowRescore && onRescore()"
	(keydown.enter)="allowRescore && onRescore()"
	(keydown.space)="allowRescore && onRescore(); $event.preventDefault()">
	<span
		class="tw-order-1 tw-w-8 tw-h-8 sm:tw-w-9 sm:tw-h-9 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-bold tw-shrink-0 tw-shadow-sm"
		[style.backgroundColor]="getScoreFaintColor(assessment.score)"
		[style.color]="getScoreTextColor(assessment.score)">
		{{ assessment.score }}
	</span>

	<ng-container *ngIf="phaseBadgeText as phaseText">
		<span
			class="tw-order-2 tw-text-[10px] sm:tw-text-xs tw-font-semibold tw-px-1.5 sm:tw-px-2 tw-py-0.5 tw-rounded tw-text-white tw-shrink-0"
			[style.backgroundColor]="phaseAccentHex"
			[ngClass]="{ 'tw-bg-slate-500': !phaseAccentHex }">
			{{ phaseText }}
		</span>
	</ng-container>

	<span class="tw-order-4 sm:tw-order-3 tw-text-xs sm:tw-text-sm tw-text-gray-700 tw-font-medium tw-basis-full sm:tw-basis-0 sm:tw-flex-1 tw-min-w-0 tw-leading-snug">
		{{ assessment.question?.question }}
	</span>

	<ng-container *ngIf="templateBadgeText as templateText">
		<span class="tw-order-3 sm:tw-order-4 tw-text-[10px] tw-font-bold tw-px-1.5 sm:tw-px-2 tw-py-0.5 tw-rounded tw-bg-slate-100 tw-text-para-primary tw-border tw-border-slate-200 tw-shrink-0">
			{{ templateText }}
		</span>
	</ng-container>

	<button
		*ngIf="allowDelete"
		type="button"
		class="tw-order-5 tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-gray-300 hover:tw-text-red-500 hover:tw-bg-red-50 tw-transition-all tw-border-0 tw-bg-transparent tw-cursor-pointer tw-shrink-0 tw-ml-auto sm:tw-ml-0"
		[ngbPopover]="alertContent"
		popoverTitle="Remove this score?"
		placement="top"
		(click)="$event.stopPropagation()">
		<i class="fa fa-trash-o tw-text-xs" aria-hidden="true"></i>
	</button>
</div>

<ng-template #alertContent>
	<div class="tw-flex tw-justify-center tw-gap-2 tw-py-1">
		<button
			type="button"
			(click)="onRemove()"
			class="tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-white tw-bg-red-500 tw-border-0 tw-rounded-md hover:tw-bg-red-600 tw-cursor-pointer tw-transition-colors">
			Yes, remove
		</button>
		<button
			type="button"
			class="tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-gray-100 tw-border-0 tw-rounded-md hover:tw-bg-gray-200 tw-cursor-pointer tw-transition-colors">
			Cancel
		</button>
	</div>
</ng-template>
